import { render, staticRenderFns } from "./userRoles.vue?vue&type=template&id=45d63de2&scoped=true&"
import script from "./userRoles.vue?vue&type=script&lang=js&"
export * from "./userRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d63de2",
  null
  
)

export default component.exports